import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UserStore } from '@store/user/user.store';
import { AlertTypeEnum } from '@akmf/ngx-ui-lib';
import { Toasts } from '@core/services/toast.service';

export const errorHandlerInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const userStore = inject(UserStore);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status >= 500 && error.status < 600) {
        router.navigate(['/error', error.status]);
      } else if (error.status === 403) {
        sessionStorage.clear();
        localStorage.removeItem('auth');
        userStore.clearState();
        window.location.href = `${environment.authUrl}/auth/logout?redirect=${environment.redirectLogout}`;
      } else if (error.status >= 400 && error.status < 500) {
        Toasts.show({
          severity: AlertTypeEnum.Error,
          life: 5000,
          icon: 'mso ms-error',
          summary: 'error.global',
        });
      }
      return throwError(() => error);
    })
  );
};
